export function copperTotal(units, rate, buying=true){
 if(!Number.isSafeInteger(units)||units<=0||!Number.isSafeInteger(rate)||rate<=0)return null;
 const product=BigInt(units)*BigInt(rate),result=(product+(buying?9999n:0n))/10000n;
 return result>0n&&result<=9000000000000000n?Number(result):null;
}
